import { render, staticRenderFns } from "./OpenAccount.vue?vue&type=template&id=7a8bccdc&scoped=true"
import script from "./OpenAccount.vue?vue&type=script&lang=js"
export * from "./OpenAccount.vue?vue&type=script&lang=js"
import style0 from "./OpenAccount.vue?vue&type=style&index=0&id=7a8bccdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8bccdc",
  null
  
)

export default component.exports